/**
 * Filter Options and Constants
 * Shared filter values and price logic
 */

export const CARD_TYPES = [
  { id: 'unit', label: 'Unit' },
  { id: 'spell', label: 'Spell' },
  { id: 'rune', label: 'Rune' },
  { id: 'battlefield', label: 'Battlefield' },
  { id: 'legend', label: 'Legend' },
  { id: 'champion', label: 'Champion' },
  { id: 'token unit', label: 'Token Unit' },
  { id: 'token gear', label: 'Token Gear' }
];

export const RARITIES = [
  { id: 'common', label: 'Common' },
  { id: 'uncommon', label: 'Uncommon' },
  { id: 'rare', label: 'Rare' },
  { id: 'epic', label: 'Epic' },
  { id: 'showcase', label: 'Showcase' }
];

export const DOMAINS = [
  { id: 'fury', label: 'Fury' },
  { id: 'calm', label: 'Calm' },
  { id: 'body', label: 'Body' },
  { id: 'mind', label: 'Mind' },
  { id: 'order', label: 'Order' },
  { id: 'chaos', label: 'Chaos' },
  { id: 'colourless', label: 'Colourless' }
];

export const SET_OPTIONS = [
  { id: 'OGN', label: 'Origins' },
  { id: 'OGS', label: 'Proving Grounds' },
  { id: 'SFD', label: 'Spiritforged' }
];

/** Energy cost options for Cost Filter */
export const ENERGY_OPTIONS = [
  { id: '0', label: '0' }, { id: '1', label: '1' }, { id: '2', label: '2' },
  { id: '3', label: '3' }, { id: '4', label: '4' }, { id: '5', label: '5' },
  { id: '6', label: '6' }, { id: '7', label: '7' }, { id: '8', label: '8' }
];

/** Common tags for Tags Filter (extend from API later if needed) */
export const TAGS_OPTIONS = [
  'Ahri', 'Ionia', 'Mech', 'Piltover', 'Piltover & Zaun', 'Freljord', 'Noxus', 'Demacia'
];

export const RARE_AND_ABOVE = ['Rare', 'Epic', 'Showcase'];

/**
 * Check if rarity is Rare or above
 */
export function isRareOrAbove(rarity) {
  return RARE_AND_ABOVE.includes(rarity);
}

/**
 * Check if card is a basic rune (Common/Uncommon rune)
 */
export function isBasicRune(rarity, type) {
  return (rarity === 'Common' || rarity === 'Uncommon') && /rune/i.test(type);
}

/**
 * Get display price value
 * Logic: Promo always foil, Basic runes normal only, Rare+ prefer foil, others prefer normal
 */
export function getDisplayPriceValue(price, rarity, type, isPromo) {
  if (!price) return null;

  // Promo cards always use foil price
  if (isPromo) {
    return price.foil ?? price.normal ?? null;
  }

  // Basic runes (Common/Uncommon) use normal price only
  if (isBasicRune(rarity, type)) {
    return price.normal ?? null;
  }

  // Rare+ cards prefer foil price
  if (isRareOrAbove(rarity)) {
    return price.foil ?? price.normal ?? null;
  }

  // Other cards prefer normal, fallback to foil
  return price.normal ?? price.foil ?? null;
}
